import { createApi } from '@reduxjs/toolkit/query/react';
import { GridData } from 'api';
import { axiosBaseQuery } from 'api/axiosBaseQuery';
import {
  convertExternalProviderMappingsToDataGrid,
  ExternalProviderMapping,
  ExternalProviderMappingResponse,
  ExternalProviderSearchRequest,
} from './externalProviderMapping';

export const externalProviderMappingApi = createApi({
  reducerPath: 'externalProviderMappingApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['ExternalProviderMappingItems'],
  endpoints: builder => ({
    getExternalProviderMappings: builder.query<
      GridData,
      ExternalProviderSearchRequest
    >({
      query: searchRequest => ({
        url: `databricks/externalProviderMapping`,
        method: 'POST',
        data: searchRequest,
      }),
      transformResponse: (
        providerResponse: ExternalProviderMappingResponse,
        meta
      ) => convertExternalProviderMappingsToDataGrid(providerResponse),
      providesTags: externalMappingProviderMappings => [
        { type: 'ExternalProviderMappingItems', id: 'LIST' },
      ],
    }),
    updateExternalProviderMapping: builder.mutation<
      ExternalProviderMapping,
      ExternalProviderMapping
    >({
      query: provider => ({
        url: `databricks/externalProviderMapping`,
        method: 'PUT',
        data: provider,
      }),
      invalidatesTags: [{ type: 'ExternalProviderMappingItems', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetExternalProviderMappingsQuery,
  useLazyGetExternalProviderMappingsQuery,
  useUpdateExternalProviderMappingMutation,
} = externalProviderMappingApi;
